import { essResetMachinesState } from '../../components/store/slices/essSwitchSlice';
import { tesResetMachinesState } from '../../components/store/slices/tesSwitchSlice';
import { tgsResetMachinesState } from '../../components/store/slices/tgsSwitchSlice';

export const shutOffHandler = (
  dispatch,
  state,
  scope,
  type,
  location,
  machine,
  specificLocation,
  zones,
  swt,
  messageBoxHandler,
) => {
  if (state === 'on') {
    if (swt === 'ESS') {
      dispatch(
        essResetMachinesState({
          location,
          specificLocation,
          machine,
          essZones: zones,
        }),
      );
    } else if (swt === 'TGS') {
      dispatch(
        tgsResetMachinesState({
          location,
          specificLocation,
          machine,
          tgsZones: zones,
        }),
      );
    } else if (swt === 'TES') {
      dispatch(
        tesResetMachinesState({
          location,
          specificLocation,
          machine,
          tesZones: zones,
        }),
      );
    }
  } else {
    messageBoxHandler(state, scope, type, 'deactivate');
  }
};
